import React from 'react';

const PatientGoalsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6847_96236)">
      <path
        d="M17.8182 7.09093C18.1193 7.09093 18.3636 6.84655 18.3636 6.54546V3.8182C18.3636 2.916 17.6295 2.18184 16.7273 2.18184H15.8082C15.194 0.894018 13.8827 0 12.3637 0H8.00004C6.48093 0 5.16969 0.894018 4.55549 2.18184H3.63636C2.73417 2.18184 2 2.916 2 3.8182V22.3637C2 23.2659 2.73417 24.0001 3.63636 24.0001H16.7273C17.6295 24.0001 18.3636 23.2659 18.3636 22.3637V19.6364C18.3636 19.3353 18.1193 19.0909 17.8182 19.0909C17.5171 19.0909 17.2727 19.3353 17.2727 19.6364V22.3636C17.2727 22.6642 17.0278 22.9091 16.7272 22.9091H3.63636C3.33584 22.9091 3.09089 22.6642 3.09089 22.3636V3.8182C3.09089 3.51762 3.33584 3.27273 3.63636 3.27273H4.22546C4.19984 3.45166 4.18184 3.63273 4.18184 3.8182V4.90909C4.18184 5.21019 4.42622 5.45457 4.72731 5.45457H15.6364C15.9375 5.45457 16.1819 5.21019 16.1819 4.90909V3.8182C16.1819 3.63273 16.1639 3.45166 16.1382 3.27273H16.7273C17.0278 3.27273 17.2728 3.51762 17.2728 3.8182V6.54546C17.2728 6.84655 17.5171 7.09093 17.8182 7.09093ZM15.0909 4.36362H5.27273V3.8182C5.27273 2.31438 6.49617 1.09094 7.99999 1.09094H12.3636C13.8674 1.09094 15.0909 2.31438 15.0909 3.8182V4.36362H15.0909Z"
        fill="#2C2543"
      />
      <path
        d="M10.1818 3.27271C10.4831 3.27271 10.7273 3.02849 10.7273 2.72723C10.7273 2.42598 10.4831 2.18176 10.1818 2.18176C9.88057 2.18176 9.63635 2.42598 9.63635 2.72723C9.63635 3.02849 9.88057 3.27271 10.1818 3.27271Z"
        fill="#2C2543"
      />
      <path
        d="M14.5454 7.09094H5.81818C5.51709 7.09094 5.27271 7.33532 5.27271 7.63641C5.27271 7.93751 5.51709 8.18184 5.81818 8.18184H14.5455C14.8466 8.18184 15.0909 7.93745 15.0909 7.63636C15.0909 7.33527 14.8465 7.09094 14.5454 7.09094Z"
        fill="#2C2543"
      />
      <path
        d="M11.8182 9.81818H5.81818C5.51709 9.81818 5.27271 10.0626 5.27271 10.3636C5.27271 10.6647 5.51709 10.9091 5.81818 10.9091H11.8182C12.1193 10.9091 12.3636 10.6647 12.3636 10.3636C12.3636 10.0626 12.1193 9.81818 11.8182 9.81818Z"
        fill="#2C2543"
      />
      <path
        d="M11.2727 12.5455H5.81818C5.51709 12.5455 5.27271 12.7899 5.27271 13.0909C5.27271 13.392 5.51709 13.6364 5.81818 13.6364H11.2727C11.5738 13.6364 11.8182 13.392 11.8182 13.0909C11.8182 12.7899 11.5738 12.5455 11.2727 12.5455Z"
        fill="#2C2543"
      />
      <path
        d="M14.5454 18H10.1818C9.88073 18 9.63635 18.2444 9.63635 18.5455C9.63635 18.8466 9.88073 19.0909 10.1818 19.0909H14.5454C14.8465 19.0909 15.0909 18.8466 15.0909 18.5455C15.0909 18.2444 14.8465 18 14.5454 18Z"
        fill="#2C2543"
      />
      <path
        d="M7.99996 18H5.81813C5.51709 18 5.27271 18.2444 5.27271 18.5455C5.27271 18.8466 5.51709 19.0909 5.81818 19.0909H8.00001C8.3011 19.0909 8.54549 18.8466 8.54549 18.5455C8.54543 18.2444 8.30105 18 7.99996 18Z"
        fill="#2C2543"
      />
      <path
        d="M11.8182 15.2728H5.81818C5.51709 15.2728 5.27271 15.5171 5.27271 15.8182C5.27271 16.1193 5.51709 16.3637 5.81818 16.3637H11.8182C12.1193 16.3637 12.3636 16.1193 12.3636 15.8182C12.3636 15.5171 12.1193 15.2728 11.8182 15.2728Z"
        fill="#2C2543"
      />
      <path
        d="M17.8182 8.18182C15.1116 8.18182 12.9091 10.3844 12.9091 13.0909C12.9091 15.7975 15.1116 18 17.8182 18C20.5247 18 22.7272 15.7975 22.7272 13.0909C22.7272 10.3844 20.5247 8.18182 17.8182 8.18182ZM17.8182 16.9091C15.7127 16.9091 14 15.1964 14 13.0909C14 10.9854 15.7127 9.27272 17.8182 9.27272C19.9236 9.27272 21.6364 10.9855 21.6364 13.0909C21.6364 15.1964 19.9236 16.9091 17.8182 16.9091Z"
        fill="#2C2543"
      />
      <path
        d="M19.7355 10.9871C19.4769 10.8322 19.142 10.9157 18.9871 11.1742L17.7102 13.3026L16.568 12.1604C16.3547 11.9471 16.01 11.9471 15.7967 12.1604C15.5834 12.3737 15.5834 12.7184 15.7967 12.9317L17.4331 14.568C17.5351 14.6706 17.6742 14.7273 17.8182 14.7273C17.8405 14.7273 17.8629 14.7263 17.8847 14.7235C18.0516 14.7028 18.1994 14.6068 18.2856 14.4628L19.922 11.7355C20.0775 11.4769 19.9934 11.142 19.7355 10.9871Z"
        fill="#2C2543"
      />
    </g>
    <defs>
      <clipPath id="clip0_6847_96236">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PatientGoalsIcon;
